module.exports = function() {
  return new Worker("/" + "babel-transpiler.dc3397b1.worker.js");
};